// src/components/quote/StepLeadForm.jsx
import React from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
} from "@mui/material";
import { FiUser, FiPhone, FiMail } from "react-icons/fi";

/*  Este formulario ahora:
    • admite que `defaultValues` venga undefined  → se auto-inicializa
    • valida formato de e-mail y teléfono
    • dispara onComplete SOLO si hay cambios (opcional)            */
export default function StepLeadForm({ defaultValues = {}, onComplete }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({ defaultValues });

  /* ——— estilos (no tocar) ——— */
  const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: 3 } };

  /* ——— envío ——— */
  const submit = (data) => {
    // si alguno de los campos cambió -> continuamos
    if (isDirty) onComplete?.(data);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(submit)}
      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
    >
      <Typography variant="subtitle1" fontWeight={700}>
        1. Ingresa tus datos de contacto
      </Typography>

      {/* —— Nombre —— */}
      <TextField
        placeholder="Nombre completo"
        error={!!errors.name}
        helperText={errors.name?.message}
        {...register("name", { required: "Obligatorio" })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiUser size={18} />
            </InputAdornment>
          ),
        }}
        sx={fieldSx}
      />

      {/* —— Teléfono —— */}
      <TextField
        placeholder="Teléfono"
        error={!!errors.phone}
        helperText={errors.phone?.message}
        {...register("phone", {
          required: "Obligatorio",
          pattern: {
            value: /^[0-9\s()+-]{7,20}$/,
            message: "Teléfono inválido",
          },
        })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiPhone size={18} />
            </InputAdornment>
          ),
        }}
        sx={fieldSx}
      />

      {/* —— Email —— */}
      <TextField
        placeholder="Correo electrónico"
        type="email"
        error={!!errors.email}
        helperText={errors.email?.message}
        {...register("email", {
          required: "Obligatorio",
          pattern: {
            value: /^\S+@\S+\.\S+$/,
            message: "Correo inválido",
          },
        })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiMail size={18} />
            </InputAdornment>
          ),
        }}
        sx={fieldSx}
      />

      {/* —— CTA —— */}
      <Button
        type="submit"
        variant="contained"
        size="large"
        sx={{
          alignSelf: "flex-end",
          mt: 1,
          textTransform: "none",
          px: 4,
          borderRadius: 3,
        }}
      >
        Siguiente
      </Button>
    </Box>
  );
}
